(async () => {
  const SELECTORS = [".price-ht", ".f-price-item span.unit"];

  // Helper: hide or show elements
  function toggleForFrance(isFrance) {
    document.querySelectorAll(SELECTORS.join(",")).forEach((el) => {
      el.style.display = isFrance ? "" : "none";
    });
  }

  // Default: hide
  toggleForFrance(false);

  const url = window.Shopify.routes.root + "browsing_context_suggestions.json";

  try {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
    const json = await res.json();

    const handle = json?.detected_values?.country?.handle;
    console.log("🚀 ~ handle:", handle)
    const isFrance = handle === "FR"
    
    toggleForFrance(isFrance);
  } catch (err) {
    console.warn("Country detection failed", err);
    // stays hidden by default
  }

  // Optional: if theme re-renders DOM (AJAX), re-apply
  const mo = new MutationObserver(() => {
    const sample = document.querySelector(SELECTORS[0]);
    if (sample) {
      const isShown = sample.style.display !== "none";
      toggleForFrance(isShown);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
